// Dependencies
import styled from 'styled-components';

// Images
import toggleIcon from '../../../img/icons/accordion/toggle.svg';

const colorOptions = {
  white: {
    sectionPadding: '0',
    top: 'var(--color-charcoal)',
    accordion: 'var(--color-sand)',
  },
  sand: {
    sectionPadding: '4rem 0 4.5rem',
    top: 'var(--color-charcoal)',
    accordion: 'var(--color-white)',
  },
  charcoal: {
    sectionPadding: '4rem 0 4.5rem',
    top: 'var(--color-white)',
    accordion: 'var(--color-sand)',
  },
  bark: {
    sectionPadding: '4rem 0 4.5rem',
    top: 'var(--color-white)',
    accordion: 'var(--color-sand)',
  },
};

const AccordionStyles = styled.section`
  padding: ${({ bgColor }) => colorOptions[bgColor].sectionPadding};
  background-color: var(--color-${({ bgColor }) => bgColor});

  .top {
    margin-bottom: 3rem;
    text-align: center;

    .heading,
    .text {
      color: ${({ bgColor }) => colorOptions[bgColor].top};
    }
  }

  .accordion {
    padding: 2rem 1.5rem;
    background-color: ${({ bgColor }) => colorOptions[bgColor].accordion};

    .item {
      position: relative;
      border-top: 0.0625rem solid var(--color-charcoal);
      background-color: ${({ bgColor }) => colorOptions[bgColor].accordion};
      overflow: hidden;

      .summary {
        width: 100%;
        padding: 1.4rem 1.3rem 1.4rem 0;
        list-style: none;
        cursor: pointer;
        text-align: left;

        .heading {
          margin: 0;
          font-weight: var(--font-weight-regular);
          text-transform: none;
          transition: color 0.3s;
        }

        &::after {
          position: absolute;
          top: 1.6rem;
          right: 0;
          display: block;
          content: '';
          width: 1rem;
          height: 1rem;
          background-image: url(${toggleIcon});
          background-size: cover;
          transition:
            transform 0.3s,
            filter 0.3s;
        }
      }

      .expandable .content {
        padding-bottom: 2rem;
      }

      &.active .summary {
        .heading {
          color: var(--color-bark);
        }

        &::after {
          transform: rotate(90deg);
          filter: brightness(0) saturate(100%) invert(64%) sepia(21%)
            saturate(138%) hue-rotate(351deg) brightness(91%) contrast(90%);
        }
      }

      &:last-child {
        border-bottom: 0.0625rem solid var(--color-charcoal);
      }
    }
  }

  @media (min-width: 768px) {
    .accordion {
      padding: 2.5rem 2rem;

      .item .summary {
        padding-right: 1.7rem;

        &::after {
          width: 1.5rem;
          height: 1.5rem;
        }
      }
    }
  }
`;

export default AccordionStyles;
